import {
  afterNextRender,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TakerService } from 'src/app/pages/shared/taker.service';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { Taker } from 'src/app/pages/taker/taker-profile/taker.model';
import { FeatherModule } from 'angular-feather';
import { ActivitiesService } from 'src/app/pages/activities/activities.service';

@Component({
  selector: 'app-activity-card',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RouterLink,
    FeatherModule,
    LoginComponent,
    CarouselModule,
    ModalModule,
  ],
  providers: [ActivitiesService],
  templateUrl: './activity-card.component.html',
  styleUrls: [
    './activity-card.component.scss',
    '../../../../node_modules/keen-slider/keen-slider.min.css',
  ],
})
export class ActivityCardComponent implements OnInit {
  @Input() activity;
  @Input() isDashboard = false;
  @Input() isFooterActive;

  @ViewChild('photosSlider') photosSlider: ElementRef<HTMLElement>;
  @ViewChild('autoShownModal', { static: false })
  autoShownModal: ModalDirective;

  currentSlide: number = 0;
  dotHelper: Array<Number> = [];
  slider: KeenSliderInstance = null;

  notLoggedIn = false;

  takerExperiences: any;
  isAlertShown = false;
  isHome = false;
  homePaths = ['/', '/es', '/en'];
  shownDays = [
    { value: 0, text: 'Todos los días' },
    { value: 1, text: 'Lun' },
    { value: 2, text: 'Mar' },
    { value: 3, text: 'Mié' },
    { value: 4, text: 'Jue' },
    { value: 5, text: 'Vie' },
    { value: 6, text: 'Sáb' },
    { value: 7, text: 'Dom' },
  ];

  constructor(
    public translate: TranslateService,
    private takerService: TakerService,
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router
  ) {
    afterNextRender(() => {
      this.takerExperiences = localStorage.getItem('favoriteExperiences')
        ? localStorage.getItem('favoriteExperiences')
        : [];
    });
  }

  ngOnInit(): void {
    this.isHome = this.homePaths.includes(
      this.router.url.split('?')[0].split('#')[0]
    );    
  }

  ngAfterViewInit() {
    this.awaitPhotoSlider();
  }

  loadPhotoSlider() {
    this.slider = new KeenSlider(this.photosSlider.nativeElement, {
      initial: this.currentSlide,
      slideChanged: (s) => {
        this.currentSlide = s.track.details.rel;
      },
    });
    this.dotHelper = [...Array(this.slider.track.details.slides.length).keys()];
  }

  awaitPhotoSlider() {
    if (this.photosSlider) {
      this.loadPhotoSlider();
    } else {
      setTimeout(() => {
        this.awaitPhotoSlider();
      }, 300);
    }
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  getUrl(image) {
    // return !isCivitatis ? 'https://dev.venntur.com/assets/activity/files/' + image : image;
    // return !isCivitatis ? 'http://localhost:4200/assets/activity/files/' + image : image;
    return 'https://api.venntur.hub2b.travel' + image;
  }

  clickFavorite(event, activityId) {
    // Recuperar y parsear el array del localStorage, o inicializarlo si no existe
    const storedFavorites = JSON.parse(
      localStorage.getItem('favoriteExperiences') || '[]'
    );

    this.takerExperiences = storedFavorites;

    console.log('localStorage favorites: ', storedFavorites);

    console.log('TAKER ID: ', this.takerService.getId());

    if (this.takerService.getId()) {
      this.notLoggedIn = false;

      // Verificar si el `activityId` ya existe en el array
      if (storedFavorites.includes(activityId)) {
        // Si existe, eliminarlo
        storedFavorites.splice(storedFavorites.indexOf(activityId), 1);
      } else {
        // Si no existe, agregarlo
        storedFavorites.push(activityId);
      }

      // Guardar el array actualizado en `localStorage`
      localStorage.setItem(
        'favoriteExperiences',
        JSON.stringify(storedFavorites)
      );

      // Crear el objeto `taker` actualizado
      const taker = {
        favoriteExperiences: storedFavorites,
      };

      this.takerExperiences = storedFavorites;

      // Enviar los cambios al backend
      const editedTaker = new Taker(taker);
      this.takerService
        .putTaker(this.takerService.getId(), editedTaker)
        .subscribe();
    } else {
      this.takerExperiences = storedFavorites;

      console.log('localStorage favorites: ', storedFavorites);

      if (storedFavorites.includes(activityId)) {
        // Si existe, eliminarlo
        storedFavorites.splice(storedFavorites.indexOf(activityId), 1);
      } else {
        // Si no existe, agregarlo
        storedFavorites.push(activityId);
      }

      localStorage.setItem(
        'favoriteExperiences',
        JSON.stringify(storedFavorites)
      );

      //notLoggedInAlert
      this.notLoggedIn = true;

      // Mostrar alerta si no hay `takerId`
      this.isAlertShown = true;
    }
  }

  shareExperience(activity) {
    var enlace = 'https://venntur.com/product/' + activity.slug;
    var mensaje = this.translate.instant('¡Mira esta experiencia en Venntur!');

    mensaje = encodeURIComponent(mensaje);
    enlace = encodeURIComponent(enlace);

    var enlaceWhatsApp = 'https://wa.me/?text=' + mensaje + '%20' + enlace;

    window.open(enlaceWhatsApp);
  }

  setCategoryTitle(activity) {
    return activity.categories.map((obj) => obj.name).join(' / ');
  }

  setLanguagesTitle(activity) {
    return activity.languages.map((obj) => obj).join(' , ');
  }

  convertTimeToCustomFormat(inputTime: string): string {
    let formattedText;
    const [hours, minutes] = inputTime
      .split(':')
      .map((part) => parseInt(part, 10));

    if (minutes != 0) {
      formattedText = hours + ' h y ' + minutes + ' min';
    } else {
      formattedText = hours + ' h';
    }

    return formattedText;
  }

  hideModal(): void {
    this.autoShownModal.hide();
  }

  onHidden(): void {
    this.isAlertShown = false;
  }
}
